export const ADMIN = 1
export const RECLUTADOR = 2
export const RECLUTADOR_RESP = 3
export const GESTOR_OP = 4
export const SUPERUSUARIO = 5
